import Severity from '../constants/Severity';
import Tag from '../models/Tag';
import { HexColor } from '../models/common';
import { Nullish } from './typescript';

interface BackgroundColorStyle {
  background: string;
}

interface DossierTagStyle {
  background?: string;
  color?: string;
}

export function getColorHexStyle(colorHex: Nullish<HexColor>): BackgroundColorStyle | undefined {
  if (!colorHex) return undefined;
  return { background: `#${colorHex}` };
}

export function getDossierTagStyle(tag: Tag): DossierTagStyle {
  return {
    ...getColorHexStyle(tag.colorHex),
    color: getContrastingColor(tag.colorHex),
  };
}

export function getSeverityClass(severity: Severity): string {
  switch (severity) {
    case Severity.GOOD:
      return 'has-text-green';
    case Severity.CAUTION:
      return 'has-text-orange';
    case Severity.BAD:
      return 'has-text-red';
  }
}

export function getMaxSeverityClass(severities: Array<Severity>): string {
  return getSeverityClass(Math.max(...severities));
}

/**
 * @see https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
 */
export function getContrastingColor(value: Nullish<HexColor>): 'black' | 'white' | undefined {
  if (typeof value === 'string' && value.length >= 6) {
    const hexR = parseInt(value.substring(0, 2), 16);
    const hexG = parseInt(value.substring(2, 4), 16);
    const hexB = parseInt(value.substring(4, 6), 16);
    const contrastRatio = (hexR + hexG + hexB) / (255 * 3);
    return contrastRatio >= 0.5 ? 'black' : 'white';
  }
}

export function asPixels(value: number): string {
  return Math.round(value) + 'px';
}